var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiskIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 24 23",
    width: "1em",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.312 16.31l1.057-2.618 2.618 1.057-1.057 2.618-2.618-1.057zm2.733-5.802l2.645-6.545 2.618 1.058-2.645 6.545-2.618-1.058zm-7.25 3.61a2.823 2.823 0 01-2.824-2.824 2.814 2.814 0 012.823-2.823 2.824 2.824 0 110 5.647zm0-14.118C5.556 0 .5 5.057.5 11.294c0 6.238 5.057 11.294 11.294 11.294a11.294 11.294 0 0011.294-11.294C23.088 5.057 18.032 0 11.794 0z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiskIcon);
export default __webpack_public_path__ + "static/media/disk-icon.a5ea2def8c69edb8b3039fd2624c52bd.svg";
export { ForwardRef as ReactComponent };